import { render, staticRenderFns } from "./itemoptionview.vue?vue&type=template&id=918b896e&scoped=true&"
import script from "./itemoptionview.vue?vue&type=script&lang=js&"
export * from "./itemoptionview.vue?vue&type=script&lang=js&"
import style0 from "./itemoptionview.vue?vue&type=style&index=0&id=918b896e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918b896e",
  null
  
)

export default component.exports